// components
import {
  fillFormNoticePopUpTranslations,
  programAvailabilityTranslations,
} from "./components";
// pages
import {
  algorithmFormPageTranslations,
  homePageTranslations,
  nutritionPageTranslations,
  programAvailabilityPageTranslations,
  signInPageTranslations,
  signUpPageTranslations,
  workoutPageTranslations,
} from "./pages";

// ----------------------------------------------------------------------

const en = {
  pagesTranslations: {
    signInPageTranslations,
    signUpPageTranslations,
    homePageTranslations,
    nutritionPageTranslations,
    workoutPageTranslations,
    programAvailabilityPageTranslations,
    algorithmFormPageTranslations,
  },

  commonSectionsTranslations: "",
  componentsTranslations: {
    fillFormNoticePopUpTranslations,
    programAvailabilityTranslations,
  },
};
//

export default en;
